import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const PlusIcon = createSvgIcon(
  <svg viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.6259 6.87894H7.52591V11.9789H5.75791V6.87894H0.657906V5.11094H5.75791V0.0109371H7.52591V5.11094H12.6259V6.87894Z"
      fill="currentColor"
    />
  </svg>,
  'plus'
);
